import React from 'react';
import useTheme from 'branding/theme';
import useLocalization from 'localization';
import useComponentPadding from '../../hooks/useComponentPadding';
const OptionLabel = ({ htmlFor, children, isHovered, isFocused, isSelected, isInitial, noBorder, disabled, isPlaceholder, styles }) => {
    const { t } = useLocalization();
    const { colors, typography } = useTheme();
    const padding = useComponentPadding({ padding: 'regular' });
    const backgroundColor = isSelected
        ? colors.brand.secondary.beta
        : isHovered || isFocused
            ? colors.neutrals.borderBeta
            : colors.neutrals.background;
    const mergedStyles = {
        ...typography.paragraph.regular,
        ...padding,
        display: 'block',
        lineHeight: 0,
        fontWeight: 700,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: 0,
        minWidth: isPlaceholder ? 'calc(100% - 6rem)' : '100%',
        color: isInitial && disabled ? colors.neutrals.textGamma : colors.neutrals.textAlpha,
        ...{ backgroundColor },
        ...(!noBorder && !isInitial && { borderTop: '0.2rem solid' }),
        ...styles
    };
    return (React.createElement("label", { htmlFor: htmlFor, style: mergedStyles }, typeof children === 'string' ? t(String(children)) : children));
};
export default OptionLabel;
//# sourceMappingURL=OptionLabel.js.map